import styles from "./styles.module.scss";
import responsiveStyles from "./responsive-styles.module.scss";
import logo from "../../../../../assets/carclaimslogo.png";
import { Wrapper } from "../../../../reusable";
import { Link } from "react-router-dom";

export function MailReferralFooter() {
  return (
    <div className={`${styles.footer} ${responsiveStyles.footer}`}>
      <Wrapper>
        <div
          className={`${styles.innerFooter} ${responsiveStyles.innerFooter}`}
        >
          <div className={styles.footerbottom}>
            <p>
              MedWatch is a medical malpractice claims service helping patients
              who have experienced adverse effects from medication.
            </p>
            <div className={`${styles.terms} ${responsiveStyles.terms}`}>
              {/* <p>
                <a href="/documents/terms.pdf" target="__blank">
                  Terms and Conditions
                </a>
              </p>
              <p>
                <a href="/documents/privacy-policy.pdf" target="__blank">
                  Privacy Policy
                </a>
              </p> */}
            </div>
            <div className={styles.logoContainer}>
              <p style={{ color: "white" }}>
                © {new Date().getFullYear()} MedWatch | Medical Malpractice
              </p>
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
}
